﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import type { LoginPageCustomizations } from "~base/Components/Pages/Account/Login";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export default {
    useLoginSplashScreen: true,
} as LoginPageCustomizations;
